module.exports = __webpack_public_path__ + "img/06.30bd8c52.png";